import { render, staticRenderFns } from "./AppGeneralEditCRIIO.vue?vue&type=template&id=2470bba8&"
import script from "./AppGeneralEditCRIIO.vue?vue&type=script&lang=js&"
export * from "./AppGeneralEditCRIIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports